import pick from 'lodash.pick';
export default function logError(condition, msg, extras) {
    if (!condition) {
        return;
    }
    const err = msg instanceof Error ? msg : new Error(msg);
    const output = pick(err, [
        'message',
        'stack',
        'graphQLErrors',
        'networkError',
        'status',
        'statusCode'
    ]);
    console.error('Error:\n', output, '\nExtras:\n', extras);
}
//# sourceMappingURL=logError.js.map